// @ts-nocheck
import interact from 'interactjs';
import type { LabelCtrlServ } from '../LabelCtrlServ';
import { Vertex2d } from './Vertex';

export default class LabelDragger {
    static isDragging = false;
    private interact: interact.Interactable;
    private currentPosState = {
        scale: 1,
        rollTimes: 0,
    }

    constructor(private labelCtrlServ:LabelCtrlServ, private wrapper:HTMLElement, lineElementSelector:string) {
        this.interact = interact(lineElementSelector, {}).draggable({
            restrict: {
                restriction: '.ai-common-image-loader-v3__drag_boundary',
            },
            onstart: this.dragStartListener.bind(this),
            onmove: this.dragMoveListener.bind(this),
            onend: this.dragEndListener.bind(this),
            ontap(event: interact.InteractEvent) {
                event.preventDefault();
                event.stopPropagation();
            },
        });
    }

    dragStartListener(event: interact.InteractEvent) {
        LabelDragger.isDragging = true;
        const target = event.target;
        target.setAttribute('unselectable', 'on');
        this.wrapper.dataset.grabed = 'true';

        const resizeInfo = this.labelCtrlServ.reGenImageResizeInfo();
        this.currentPosState = {
            scale: resizeInfo.scale,
            rollTimes: this.labelCtrlServ.rotateNumber,
        }

        target.closest('.part-label-group').dataset.grabbing = 'true';
    }

    dragMoveListener(event: interact.InteractEvent) {
        const target = event.target;
        const partId = target.dataset['part-_id'];

        const part = this.labelCtrlServ.partsMap[partId];
        if (!part) {
            console.warn('dragMoveListener part not found', partId);
            return;
        }

        // keep the dragged position in the data-x/data-y attributes
        const scale = this.currentPosState.scale * this.labelCtrlServ.userScale;
        const deltaVertex2d = (new Vertex2d(event.dx, event.dy)).scale(1 / scale);
        const newRenderedLabelBox = part.renderedLabelBox?.translate(deltaVertex2d);

        // this.labelCtrlServ.partsMap[partId].renderedLabelBox = newRenderedLabelBox;
        this.labelCtrlServ.partsMap[partId] = {
            ...part,
            renderedLabelBox: newRenderedLabelBox,
        }
        LabelDragger.isDragging = true;
    }

    clean() {
        this.interact.unset();
    }

    dragEndListener(event:interact.InteractEvent) {
        const target = event.target;
        target.removeAttribute('unselectable');
        target.closest('.part-label-group').dataset.grabbing = 'false';
        event.stopImmediatePropagation();
        setTimeout(() => {
            LabelDragger.isDragging = false;
        }, 330); // 鼠标事件认为是个点击事件，所以延迟一下，避免误触发 onClickFigure
    }
}
